/* eslint-disable */

import React, { useState } from 'react'

import { useRouter } from 'next/router'
import { XIcon } from '@heroicons/react/outline'
interface Props {
  setShowOverLay: (show: boolean) => void
}
export default function SearchForm({ setShowOverLay }: Props) {
  const router = useRouter()
  const [searchInput, setSearchInput] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    router.push('/blog/search?title=' + searchInput)
  }
  return (
    <>
      <div className="flex mx-auto flex-col  justify-center items-center h-full w-full gap-8">
        <main className="flex flex-row md:flex-row w-full gap-8 flex-wrap  justify-center ">
          <form
            className="flex justify-center w-full border-yellow-300"
            onSubmit={handleSubmit}
          >
            {' '}
            <input
              type="text"
              className="w-full search-text mr-1 border rounded  px-4  cursor-pointer focus:outline-none"
              placeholder="enter a keyword to search "
              onChange={e => setSearchInput(e.target.value)}
            />
            <button
              type="submit"
              className="bg-brand search-submit border text-white cursor-pointer focus:outline-none"
            >
              Search
            </button>
          </form>
          <button
            className="flex items-center justify-center bg-red-700 font-bold text-white outline-none rounded-full h-12 w-12 cursor-pointer"
            onClick={() => setShowOverLay(false)}
          >
            <XIcon width={24} height={24} />
          </button>
        </main>
      </div>
    </>
  )
}
